export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoibGlnaHRtZXRyaWNzIiwiYSI6ImNsZXIzNjJmeDBvZHIzd3AyZzRxeTlybXkifQ.bkvbQRH0c2P3chHj04cXeQ';

export const VIDEO_REQUEST_EVENTS_CONFIG = {
  'Traffic-Speed-Violated': {
    label: 'Speed Limit Violation',
    color: '#005dbb',
    showEvent: true,
  },
  Cornering: {
    label: 'Harsh Cornering',
    color: '#005dbb',
    showEvent: true,
  },
  'Traffic-STOP-Sign-Violated': {
    label: 'Stop Sign Violation',
    color: '#005dbb',
    showEvent: true,
  },
  'Harsh-Braking': {
    label: 'Harsh Braking',
    color: '#ff00ff',
    showEvent: true,
  },
  'Tail-Gating-Detected': {
    label: 'Tailgating',
    color: '#005dbb',
    showEvent: true,
  },
  'Harsh-Acceleration': {
    label: 'Harsh Acceleration',
    color: '#005dbb',
    showEvent: true,
  },
  'Lane-Drift-Found': {
    label: 'Lane Drift',
    color: '#005dbb',
    showEvent: true,
  },
  'Distracted-Driving': {
    label: 'Distracted Driving',
    color: '#005dbb',
    showEvent: true,
  },
  'Forward-Collision-Warning': {
    label: 'Forward Collision Warning',
    color: '#005dbb',
    showEvent: true,
  },
  'Drowsy-Driving-Detected': {
    label: 'Drowsy Driving',
    color: '#005dbb',
    showEvent: true,
  },
  'Roll-Over-Detected': {
    label: 'Rollover Detection',
    color: '#005dbb',
    showEvent: true,
  },
  'Unbuckled-Seat-Belt': {
    label: 'Seatbelt Violation',
    color: '#003f5c',
    showEvent: true,
  },
  'Traffic-Light-Violated': {
    label: 'Traffic Light Violation',
    color: '#005dbb',
    showEvent: true,
  },
  GeofenceEntry: {
    label: 'Geofence Entry',
    showEvent: true,
  },
  GeofenceExit: {
    label: 'Geofence Exit',
    showEvent: true,
  },
};

export const MDVR_COLLAGE_CONFIG = [
  {
    collage: 'C1x1',
    validSources: 1,
    resolution: ['320x180', '640x360', '1280x720', '1920x1080'],
    liveStreamResolution: ['320x180', '640x360', '1280x720'],
    defaultResolution: '640x360',
  },
  {
    collage: 'C1x2',
    validSources: 2,
    resolution: ['640x180', '1280x360', '2560x720'],
    defaultResolution: '1280x360',
  },
  {
    collage: 'C3_1',
    validSources: 3,
    resolution: ['960x360', '1920x720'],
    defaultResolution: '960x360',
  },
  {
    collage: 'C2x2',
    validSources: 4,
    resolution: ['640x360', '1280x720', '2560x1440'],
    defaultResolution: '640x360',
  },
  {
    collage: 'C5_1',
    validSources: 5,
    resolution: ['1280x360', '2560x720'],
    defaultResolution: '1280x360',
  },
  {
    collage: 'C2x3',
    validSources: 6,
    resolution: ['960x360', '1920x720'],
    defaultResolution: '960x360',
  },
  {
    collage: 'C7_1',
    validSources: 7,
    resolution: ['1280x720', '2560x1440'],
    defaultResolution: '1280x720',
  },
];

export const MDVR_COLLAGE_SORTING_ARR = [
  'ROAD',
  'DRIVER',
  'UVC',
  'TVI1',
  'TVI2',
  'TVI3',
  'TVI4',
  'CONVOY_CH1',
  'CONVOY_CH2',
  'CONVOY_CH3',
  'CONVOY_CH4',
];

export const STANDARD_DURATIONS = [30, 60, 120, 180];
export const TIMELAPSE_DURATIONS = [300, 600, 900, 1800, 2700, 3600];

export const USAGE_MATRIX_STANDARD: Record<string, Record<string, number[]>> = {
  '320x180': {
    road: [1.1, 2.2, 4.39, 6.59],
    separate: [2.2, 4.39, 8.79, 13.18],
    pictureInPicture: [1.17, 2.34, 4.69, 7.03],
  },
  '640x360': {
    road: [3.66, 7.32, 14.65, 21.97],
    separate: [7.32, 14.65, 29.3, 43.95],
    pictureInPicture: [5.27, 10.55, 21.09, 31.64],
  },
  '1280x720': {
    road: [12.21, 24.41, 48.82, 73.24],
    separate: [24.41, 48.82, 97.66, 146.48],
    pictureInPicture: [17.58, 35.16, 70.31, 105.47],
  },
  '1920x1080': {
    road: [5.49, 10.98, 21.96, 32.93],
    separate: [10.99, 21.98, 43.95, 65.93],
    pictureInPicture: [6.59, 13.18, 26.37, 39.55],
  },
};

export const USAGE_MATRIX_TIMELAPSE: Record<string, Record<string, number[]>> = {
  '320x180': {
    pictureInPicture: [1.3, 2.5, 3.8, 7.5, 11.3, 15.0],
    road: [0.8, 1.3, 1.9, 3.8, 5.6, 7.5],
    separate: [2.1, 4.2, 6.3, 12.5, 18.8, 25.0],
  },
  '640x360': {
    pictureInPicture: [3.3, 6.7, 10.0, 20.0, 30.0, 40.0],
    road: [2.8, 5.5, 8.3, 16.5, 24.8, 33.0],
    separate: [5.4, 10.8, 16.3, 32.5, 48.8, 65.0],
  },
  '1280x720': {
    pictureInPicture: [13.6, 27.2, 40.8, 81.5, 122.3, 163.0],
    road: [6.8, 13.6, 20.4, 40.8, 61.2, 87.0],
    separate: [22.5, 45.0, 67.5, 135.0, 202.5, 270.0],
  },
  '1920x1080': {
    pictureInPicture: [17.8, 35.6, 53.4, 106.8, 160.2, 213.0],
    road: [8.9, 17.8, 26.7, 53.4, 80.1, 178.0],
    separate: [29.6, 59.2, 88.9, 177.8, 266.7, 355.0],
  },
};
